function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './re-edit.scss';
import React, { useEffect, useState } from 'react';
import Redirect from 'shared/components/Redirect';
import { T, useTranslate } from 'shared/helper/translate';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import Link from 'shared/components/Link';
import Loading from 'researcher/components/Loading';
var ReEdit = function ReEdit(_ref) {
  var order = _ref.order,
    externalId = _ref.externalId,
    fetchOrders = _ref.fetchOrders;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    orderNotFound = _useState2[0],
    setOrderNotFound = _useState2[1];
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  useEffect(function () {
    if (!order) {
      fetchOrders({
        xid: externalId
      }).then(function (json) {
        if (json.orders && json.orders.length === 0) {
          setOrderNotFound(true);
        }
      });
    }
  }, [order, externalId, fetchOrders]);
  if (orderNotFound) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  if (!order) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container new-button-styles re-edit"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "Re-edit Request"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 col-xs-12"
  }, /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement(T, {
    source: "Re-edit Request"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "**For order** %(externalId)s: %(title)s",
    params: {
      externalId: order.externalId,
      title: order.title
    }
  }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "ReEdit modal submission process"
  })), /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": t('Continue'),
    className: "btn btn-primary btn-squared pull-right",
    href: "/api/order-form/reedit/".concat(order.externalId)
  }, /*#__PURE__*/React.createElement(T, {
    source: "Continue"
  })), /*#__PURE__*/React.createElement(Link, {
    to: "/"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-chevron-left"
  }), " ", /*#__PURE__*/React.createElement(T, {
    source: "Return to my orders"
  }))))));
};
export default ReEdit;